import { postChatTokenApi } from '../api/post-chat-token.service';

export const {
  postChatTokenActions,
  postChatToken,
  postChatTokenSuccess,
  postChatTokenError,
  postChatTokenClear,
} = postChatTokenApi;
